/**
 * Applique, dès qu'on est connecté, les réglages « Réduire les animations » et « Thème »
 * enregistré côté serveur (Paramètres → Affichage) : un choix fait sur un
 * appareil vaut sur tous. Sans session, la dernière valeur connue sur cet
 * appareil s'applique (utils/affichage). Silencieux en cas d'échec.
 */
import { useEffect } from "react";
import { api, useAuth } from "../context/AuthContext";
import { useAssociationAuth } from "../context/AssociationAuthContext";
import { appliquerReduireAnimations, appliquerTheme } from "../utils/affichage";

export default function SynchroAffichage() {
  const { user } = useAuth() || {};
  const { account } = useAssociationAuth() || {};
  const connecte = !!(user || account);
  useEffect(() => {
    if (!connecte) return undefined;
    let vivant = true;
    api.get("/parametres/affichage")
      .then((r) => {
        if (!vivant || !r.data) return;
        if (typeof r.data.reduire_animations === "boolean") appliquerReduireAnimations(r.data.reduire_animations);
        if (typeof r.data.theme === "string") appliquerTheme(r.data.theme);
      })
      .catch(() => { /* réglage non lu : la valeur mémorisée reste */ });
    return () => { vivant = false; };
  }, [connecte]);
  return null;
}
